module.exports = __webpack_public_path__ + "img/email-header-relationshipwithcolleagues.a96920d7.png";